import { render, staticRenderFns } from "./edit-action.vue?vue&type=template&id=70a787ba"
import script from "./edit-action.ts?vue&type=script&lang=js&external"
export * from "./edit-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports